module.exports = __webpack_public_path__ + "static/media/timer_v2.de4467f6.svg";